import React from 'react';
import { Table } from 'react-bootstrap';

const ResponsiveTable = ({ headers, rows }) => {
    return (
        <Table responsive>
            <thead>
            <tr>
                {headers.map((header, index) => (
                    <th key={index}><span>{header}</span></th>
                ))}
            </tr>
            </thead>
            <tbody>
            {rows?.map((row, index) => (
                <tr key={index}>                    
                    {row?.map((col, index) => (
                        <td key={index}>{col}</td>
                    ))}
                </tr>
            ))}
            </tbody>
        </Table>
    );
};

export default ResponsiveTable;
